import axios from "axios";

// const apiKey = "AIzaSyCTaQzQPR09teh15mrcNAVdRR-0OehFwJk";

const patterns = {
  platePattern: /^[A-Z]{3}\d[A-Z]\d{2}$/,
  containerPattern: /^[A-Z]{4}$/,
  numericPattern: /^\d{6}$/,
  singleDigitPattern: /^\d{1}$/,
  replacements: [
    { from: "8", to: "B" },
    { from: "B", to: "8" },
    { from: "1", to: "I" },
    { from: "I", to: "1" },
    { from: "0", to: "O" },
    { from: "O", to: "0" },
    { from: "5", to: "S" },
    { from: "S", to: "5" },
    { from: "2", to: "Z" },
    { from: "Z", to: "2" },
    { from: "6", to: "G" },
    { from: "G", to: "6" },
    { from: "9", to: "Q" },
    { from: "Q", to: "9" }
  ]
};

export async function recognizeText(imageBase64, apikey) {
  const requestPayload = {
    requests: [
      {
        image: {
          content: imageBase64
        },
        features: [
          {
            type: "TEXT_DETECTION"
          }
        ]
      }
    ]
  };

  try {
    const response = await axios.post(
      `https://vision.googleapis.com/v1/images:annotate?key=${apikey}`,
      requestPayload,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    return response.data.responses[0];
  } catch (error) {
    console.error("Error recognizing text:", error);
    throw error;
  }
}

export function applyFormattingRules(response, ocrFieldType) {
  if (!response || !response.textAnnotations) {
    console.error("No textAnnotations found in the response");
    return [];
  }

  let textAnnotations = response.textAnnotations.slice(1);

  let boundingBoxes = textAnnotations.map(annotation => ({
    text: annotation.description,
    boundingBox: annotation.boundingPoly.vertices
  }));

  let formattedBoundingBoxes = [];
  let tempContainerParts = [];
  let tempVertices1 = [];
  let tempVertices2 = [];
  let tempVertices3 = [];

  for (let i = 0; i < boundingBoxes.length; i++) {
    let box = boundingBoxes[i];
    if (ocrFieldType === 3) {
      if (box.text === "-") {
        if (i > 0 && i < boundingBoxes.length - 1) {
          let prevBox = boundingBoxes[i - 1];
          let nextBox = boundingBoxes[i + 1];
          if (prevBox.text.length === 3 && nextBox.text.length === 4) {
            let combinedText = prevBox.text + box.text + nextBox.text;
            let combinedBoundingBox = [
              prevBox.boundingBox[0], // cima esquerda
              nextBox.boundingBox[1], // cima direita
              nextBox.boundingBox[2], // baixo direita
              prevBox.boundingBox[3] // baixo esquerda
            ];

            formattedBoundingBoxes.splice(i - 1, 3);
            formattedBoundingBoxes.push({
              text: combinedText,
              boundingBox: combinedBoundingBox
            });
            i++;
            continue;
          }
        }
      }
      let text = box.text;
      if (text.length === 7) {
        text = correctPlatePattern(text);
      }
      if (patterns.platePattern.test(text)) {
        formattedBoundingBoxes.push({
          text: text,
          boundingBox: box.boundingBox
        });
      } else {
        formattedBoundingBoxes.push({
          text: text,
          boundingBox: box.boundingBox
        });
      }
    } else if (ocrFieldType === 5) {
      if (patterns.containerPattern.test(box.text)) {
        tempContainerParts.push(box.text);
        tempVertices1 = box.boundingBox;
      } else if (patterns.numericPattern.test(box.text)) {
        tempContainerParts.push(box.text);
        tempVertices2 = box.boundingBox;
      } else if (patterns.singleDigitPattern.test(box.text)) {
        tempContainerParts.push(box.text);
        tempVertices3 = box.boundingBox;
        if (tempContainerParts.length === 4) {
          let combinedBoundingBox = [
            tempVertices1[0], // cima esquerda
            tempVertices3[1], // cima direita
            tempVertices3[2], // baixo direita
            tempVertices1[3] // baixo esquerda
          ];
          formattedBoundingBoxes.push({
            text: tempContainerParts.join(" "),
            boundingBox: combinedBoundingBox
          });
          tempContainerParts = [];
        }
      } else {
        if (tempContainerParts.length > 0) {
          let combinedBoundingBox = [
            tempVertices1[0], // cima esquerda
            tempVertices3[1], // cima direita
            tempVertices3[2], // baixo direita
            tempVertices1[3] // baixo esquerda
          ];
          formattedBoundingBoxes.push({
            text: tempContainerParts.join(" "),
            boundingBox: combinedBoundingBox
          });
          tempContainerParts = [];
        }
        formattedBoundingBoxes.push(box);
      }
    } else {
      formattedBoundingBoxes.push(box);
    }
  }

  return formattedBoundingBoxes;
}

function correctPlatePattern(text) {
  if (patterns.platePattern.test(text)) {
    return text;
  }

  let correctedText = "";

  for (let i = 0; i < text.length; i++) {
    let char = text[i];
    if (i < 3 || i === 4) {
      char = correctChar(char);
    } else {
      char = correctChar(char);
    }
    correctedText += char;
  }

  return correctedText;
}

function correctChar(char) {
  for (const pattern of patterns.replacements) {
    if (pattern.from === char) {
      return pattern.to;
    }
  }

  return char;
}

export function extractInformation(formattedText, ocrFieldType) {
  const patterns = {
    platePattern: /^[A-Z]{3}-\d{4}$/,
    newPlatePattern: /[A-Z]{3}[0-9][A-Z][0-9]{2}/,
    containerPattern: /[A-Z]{4}\s[0-9]{6}\s[0-9]/
  };

  let result = null;
  if (Array.isArray(formattedText)) {
    if (ocrFieldType === 4) {
      let longestTextItem = formattedText.reduce((max, item) => {
        return item.text.length > max.text.length ? item : max;
      }, formattedText[0]);
      result = longestTextItem.text;
    } else {
      for (let item of formattedText) {
        let text = item.text;
        if (ocrFieldType == 3) {
          const matchOld = text.match(patterns.platePattern);
          const matchNew = text.match(patterns.newPlatePattern);
          if (matchOld) {
            result = matchOld[0];
            break;
          } else if (matchNew) {
            result = matchNew[0];
            break;
          } else {
            result = text;
          }
        } else if (ocrFieldType == 5) {
          const match = text.match(patterns.containerPattern);
          if (match) {
            result = match[0];
            break;
          } else {
            result = text;
          }
        } else {
          result = text;
          break;
        }
      }
    }
  }
  return result;
}

export { patterns };
